import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { EnactTextCounterComponent } from './enact-text-counter.component';
import { NumbersOnlyDirective } from '@lib-ui/lib/common/directives/numbers-only.directive';
import { TranslateModule } from '@ngx-translate/core';
import { StringingTooltipDirective } from '@lib-ui/lib/common/directives/stringing-tooltip.directive';
import { TooltipContentComponent } from '../custom-string-tooltip/custom-string-tooltip.component';

@NgModule({
    declarations: [
        EnactTextCounterComponent,
        NumbersOnlyDirective,
        TooltipContentComponent,
        StringingTooltipDirective

    ],
    imports: [
        CommonModule,
        MatRippleModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        TranslateModule
    ],
    exports: [
        EnactTextCounterComponent
    ]
})
export class EnactTextCounterModule { }